var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 404 556",
    style: {
      enableBackground: "new 0 0 404 556"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,556.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1735,5465c-141-23-290-63-415-112C675,5101,214,4522,116,3840c-17-121-23-340-11-425 c83-581,627-1565,1545-2790c254-339,416-545,429-545c15,0,338,444,569,782c717,1048,1156,1896,1268,2447c59,290,17,651-111,972 c-240,598-757,1028-1399,1165c-106,23-150,27-351,30C1887,5478,1801,5475,1735,5465z M2228,5069c421-51,823-307,1069-681 c390-593,310-1387-191-1893c-300-304-664-457-1086-457c-98,0-188,6-245,16c-656,117-1145,606-1260,1261c-21,120-21,370,0,490 c56,322,202,603,429,831C1287,4978,1735,5129,2228,5069z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2190,3710l-555-459l-80,77c-44,42-119,115-168,162l-87,85l-77-78l-78-77l235-235c129-129,238-234,242-233 c12,5,1268,1043,1268,1048c0,8-129,165-137,167C2748,4168,2495,3962,2190,3710z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpoint);
export default __webpack_public_path__ + "static/media/checkpoint.d663dd1a0fab88a6b4b915c4b0967fd3.svg";
export { ForwardRef as ReactComponent };